import { CalendarCheck, UserPlus } from "lucide-react";

export default function ChoiceStep({ onChoose }) {
  return (
    <div className="max-w-2xl mx-auto text-center space-y-10 pt-8" data-testid="checkin-choice-step">
      <div>
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-cyan">Gate Check-In</span>
        <h1 className="text-3xl sm:text-4xl font-black uppercase tracking-tighter text-brand-navy mt-2">How is this visitor arriving?</h1>
        <p className="text-slate-500 mt-2">Choose pre-registered if the visitor has an invite, otherwise walk-in.</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <button
          data-testid="choice-prereg-button"
          onClick={() => onChoose("prereg")}
          className="h-48 border border-slate-200 bg-white shadow-sm hover:shadow-lg hover:border-brand-cyan hover:-translate-y-0.5 transition-all flex flex-col items-center justify-center gap-3 rounded-lg"
        >
          <div className="w-14 h-14 rounded-full bg-brand-cyan/10 text-brand-cyan flex items-center justify-center">
            <CalendarCheck size={28} />
          </div>
          <span className="text-lg font-bold uppercase tracking-wide text-brand-navy">Pre-Registered</span>
          <span className="text-xs text-slate-400">Visitor has an invite</span>
        </button>
        <button
          data-testid="choice-walkin-button"
          onClick={() => onChoose("walkin")}
          className="h-48 border border-slate-200 bg-white shadow-sm hover:shadow-lg hover:border-slate-400 hover:-translate-y-0.5 transition-all flex flex-col items-center justify-center gap-3 rounded-lg"
        >
          <div className="w-14 h-14 rounded-full bg-slate-100 text-slate-700 flex items-center justify-center">
            <UserPlus size={28} />
          </div>
          <span className="text-lg font-bold uppercase tracking-wide text-brand-navy">Walk-In</span>
          <span className="text-xs text-slate-400">No prior registration</span>
        </button>
      </div>
    </div>
  );
}
